"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSummaryMap = void 0;
const React = require("react");
const react_1 = require("react");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const GoogleMaps_1 = require("../../../../../../components/base/atoms/GoogleMaps");
const useConfig_1 = require("../../../../../../hooks/useConfig");
const constants_1 = require("../../../helpers/constants");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SalesOrderSummaryMap");
const SalesOrderSummaryMap = ({ salesOrder, variant, isVisible }) => {
    const { googleApiKey, googleMapStyleId } = (0, useConfig_1.useConfig)();
    const { retailLocation: { title, address: { lat: retailLocationLat, lng: retailLocationLng } }, retailLocation, type, deliveryAddress: { fullAddress = "", lat = null, lng = null } = {}, deliveryDriver, completedAt, isDeliveryDriverWithCar } = salesOrder;
    const deliveryPartnerStatus = salesOrder === null || salesOrder === void 0 ? void 0 : salesOrder.externalDeliveryStatus;
    const markers = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        if (!retailLocation) {
            return null;
        }
        const currentPositionMarker = [];
        if (type === TSalesOrderType_1.TSalesOrderType.Delivery) {
            currentPositionMarker.push({
                title: fullAddress,
                position: { lat, lng },
                clickable: false
            });
        }
        const retailLocationMarker = [
            {
                title: title,
                position: {
                    lat: retailLocationLat,
                    lng: retailLocationLng
                },
                icon: {
                    url: constants_1.TRestaurantMapMarkers.Selected,
                    scaledSize: new google.maps.Size(36, 50)
                },
                clickable: false
            }
        ];
        let deliveryDriverMarker = [];
        if (!completedAt && (deliveryDriver === null || deliveryDriver === void 0 ? void 0 : deliveryDriver.location)) {
            deliveryDriverMarker = [
                {
                    title: (_a = deliveryDriver.name) !== null && _a !== void 0 ? _a : "Driver",
                    position: {
                        lat: (_b = deliveryDriver === null || deliveryDriver === void 0 ? void 0 : deliveryDriver.location) === null || _b === void 0 ? void 0 : _b.lat,
                        lng: (_c = deliveryDriver === null || deliveryDriver === void 0 ? void 0 : deliveryDriver.location) === null || _c === void 0 ? void 0 : _c.lng
                    },
                    icon: {
                        url: constants_1.deliveryDriverIcon,
                        scaledSize: new google.maps.Size(31, 42)
                    },
                    clickable: false
                }
            ];
        }
        return currentPositionMarker.concat(retailLocationMarker, deliveryDriverMarker);
    }, [isVisible, deliveryDriver]);
    return (React.createElement("div", { className: css("", {
            ["-isDesktop"]: variant === "desktop" && isVisible,
            ["-isMobile"]: variant === "mobile" && isVisible
        }) },
        React.createElement(GoogleMaps_1.GoogleMaps, { mapId: `${variant}Map`, center: {
                lat: lat || retailLocationLat,
                lng: lng || retailLocationLng
            }, zoom: lat && lng ? null : 15, width: "100%", height: "100%", markers: markers, apiKey: googleApiKey, mapStyleId: googleMapStyleId, hideUI: true, deliveryPartnerStatus: deliveryPartnerStatus, isDeliveryDriverWithCar: isDeliveryDriverWithCar })));
};
exports.SalesOrderSummaryMap = SalesOrderSummaryMap;
//# sourceMappingURL=index.js.map